import { BusReportMode } from '../../report.models';
import { toEnglishDigits } from '../../report.utils';
import { BusReportColumn, BusReportCredentials, BusReportFilters, BusReportRequest, BusReportRow } from './bus-report.models';

export const BUS_PAGE_SIZE = 20;
export const BUS_PAGE_SIZE_OPTIONS = [10, 20, 50];

const COLUMNS: Record<BusReportMode, BusReportColumn[]> = {
  'bus-presence': [
    { field: 'strBusLineName', title: 'نام خط' },
    { field: 'strBusLineCode', title: 'کد خط' },
    { field: 'strBusStopName', title: 'نام ایستگاه' },
    { field: 'strBusStopCode', title: 'کد ایستگاه' },
    { field: 'strTime', title: 'ساعت حضور در ایستگاه' },
  ],
  'station-presence': [
    { field: 'strFullName', title: 'نام اتوبوس' },
    { field: 'strVehicleNo', title: 'پلاک اتوبوس', format: 'plate' },
    { field: 'strBusLineName', title: 'نام خط' },
    { field: 'strTime', title: 'ساعت حضور در ایستگاه' },
  ],
};

export function getBusReportColumns(mode: BusReportMode): BusReportColumn[] {
  return COLUMNS[mode];
}

export function buildBusReportPayload(
  mode: BusReportMode,
  filters: BusReportFilters,
  credentials: BusReportCredentials,
): BusReportRequest {
  return mode === 'bus-presence'
    ? { ...credentials, strUnitID: filters.bus, strDate: toEnglishDigits(filters.startDate) }
    : { ...credentials, iBusStop: filters.stop, strSDate: toEnglishDigits(filters.startDate), strEDate: toEnglishDigits(filters.endDate) };
}

export function buildBusSearchIndex(row: BusReportRow): string {
  return toEnglishDigits(Object.entries(row)
    .filter(([key]) => key !== 'searchIndex')
    .map(([, value]) => value ?? '').join(' ')).toLowerCase();
}
